export const SMS_ALERT_REPEAT_LOGIN = "login";
export const SMS_ALERT_REPEAT_ONCE_A_DAY = "once_a_day";
export const SMS_ALERT_REPEAT_CUSTOM = "custom";
export const SMS_ALERT_REPEAT_EVERY_20 = "every_20";

export const SMS_ALERT_SETTING_DEFAULTS = {
  repeat_mode: SMS_ALERT_REPEAT_ONCE_A_DAY,
  custom_minutes: 20,
  interval_minutes: 60,
  threshold: 20,
};

const clampThreshold = (value) => {
  let threshold = parseInt(value, 10);
  if (!threshold || threshold < 1) {
    threshold = 20;
  }
  if (threshold > 10000) {
    threshold = 10000;
  }
  return threshold;
};

export const getSmsAlertSettings = (settings) => {
  let parsed = settings;

  if (typeof settings === "string") {
    try {
      parsed = JSON.parse(settings);
    } catch (error) {
      parsed = {};
    }
  }

  const merged = {
    ...SMS_ALERT_SETTING_DEFAULTS,
    ...(parsed && typeof parsed === "object" ? parsed : {}),
  };

  let repeatMode = merged.repeat_mode;
  if (repeatMode === SMS_ALERT_REPEAT_EVERY_20) {
    repeatMode = SMS_ALERT_REPEAT_ONCE_A_DAY;
  }
  if (![SMS_ALERT_REPEAT_LOGIN, SMS_ALERT_REPEAT_ONCE_A_DAY, SMS_ALERT_REPEAT_CUSTOM].includes(repeatMode)) {
    repeatMode = SMS_ALERT_REPEAT_ONCE_A_DAY;
  }

  let customMinutes = parseInt(merged.custom_minutes, 10);
  if (!customMinutes || customMinutes < 1) {
    customMinutes = 20;
  }
  if (customMinutes > 1440) {
    customMinutes = 1440;
  }

  const threshold = clampThreshold(merged.threshold);

  return {
    repeat_mode: repeatMode,
    custom_minutes: customMinutes,
    threshold,
    interval_minutes:
      repeatMode === SMS_ALERT_REPEAT_LOGIN ? 0 : repeatMode === SMS_ALERT_REPEAT_ONCE_A_DAY ? 60 : customMinutes,
  };
};
